import React, { useContext, useEffect, useState } from 'react'
import './DependencyModal.css'
import dayjs from 'dayjs';
import { modifyTimezoneString } from '../../../components/HR/TimeClock/Util';
import AwsServerService from '../../../common/util/AwsServerService';
import AppContext from '../../../Context/AppContext';
import { useHistory } from "react-router-dom";
import { CustomeTableComponent } from './DependencyTable/CustomeTableComponent';

export default function ReminderForTasks({task, allUsers, refreshReminder}) {
    const [loader, setLoader] = useState(false);  
    const [data, setData] = useState([]);  
    const [items, setItems] = useState([]);  
    const history = useHistory();
    const appData=useContext(AppContext);
    const { state, dispatch } = appData || {};
    const userInfo = JSON.parse(localStorage.getItem('userinfo'));   
    useEffect(()=>{
      let taskId=task.hasOwnProperty('SubTaskROWID')?task.SubTaskROWID:task.TaskROWID;
      if(taskId){
        // let obj={messageId:taskId,module:'Task'};
        AwsServerService.getTaskReminder(taskId, 'Task').then(res=>{
          console.log(res); 
          res.data[0] = res.data[0].filter(e=> e.module == "Task")
          setData(res.data[0]);
        })
      }
    },[task, refreshReminder])

    const getUserThumbnailUrl = (zuid) => {
      const loginProfileUrl =
        "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";
      return loginProfileUrl;
    }
    const RenderChildren = (data,index) => {
      data = data?.data ? data?.data : data;
      let user = allUsers?.length>0 ?allUsers?.find(d => d.email == data?.userEmail) || "USER":"USER";
      return (
        <div className="Activity-Data-Wrapper">
          <span style={{ minWidth: "2rem"}}>
            <img
              className="User-Image"
              src={getUserThumbnailUrl(user?.zuid)}
            />
          </span>
          <div>
            <p className="activity-message">
              { user?.id ? <a
                              key={index}
                              href="#"
                              onClick={(e) => {
                                  e.preventDefault();
                                  history.push({
                                      pathname: `/setting/users/${user?.id}/Users`,
                                      state: { tab: "Users" },
                                  });
                              }}
                              className="user-link"
                          >
                              {user?.full_name+ " "}
                          </a> : user}
                    {' created reminder on '+ dayjs(modifyTimezoneString(data?.reminderTime)).format("MMM DD YYYY hh:mm A")}
            </p>
            {/* <span className="activity-date">
              {dayjs(modifyTimezoneString(data?.CREATEDTIME)).format("MMM DD YYYY hh:mm A")}
            </span> */}
          </div>
        </div>
      );
    };
    console.log("allUsers", allUsers)
    useEffect(e => {
      if (data) {
        let resData=[...data];
        resData = resData.filter(e=> e.module == "Task")
        console.log("resData ==>", resData)
        let temp = resData.map((item, index) => {
            return {
              children: <RenderChildren data={item} index={index}/>,
            };
          }); 
          console.log(temp);
          
        setItems(temp)
      }else{
        setItems([]);
      }
    }, [data])
    
  const DependanciesHeaders = [
    {
      label: "Created Time",
      field: "Created Time",
      render: (data, field) => {
        return (
          <span>{dayjs(modifyTimezoneString(data?.CREATEDTIME)).format("MMM DD YYYY hh:mm A")}</span>
        );
      }
    },
    {
      label: "Created By",
      field: "Created By",
      render: (data, field) => {
        let createdBy = allUsers.find(e=> e.email == data.userEmail)
        return (
          <span>{createdBy.full_name}</span>
        );
      }
    },
    {
      label: "Reminder Title",
      field: "Reminder Heading",
      render: (data, field) => {
        return (
          <span className='Elipsis-Class' style={{display:"inline-block"}} title={data.reminderHeading}>{data.reminderHeading}</span>
        );
      }
    },
    // {
    //   label: "Actions",
    //   field: "Actions",
    //   render: (data, field) => {
    //     return (
    //       <div className="Hover-Buttons">
    //                   <Tooltip title="View in Workdrive">
    //                     <Button
    //                       className=""
    //                       type="default"
    //                       icon={<img style={{ width: "auto", height: "24px", cursor: 'pointer' }} src={icon} />}
    //                       style={{ width: "max-content", padding: "0px 5px" }}
    //                       onClick={(e) => {
    //                         window.open(data.permalink);
    //                       }}
    //                     >
    //                       View
    //                     </Button>
    //                   </Tooltip>
    //                   <Tooltip title="Delete">
    //                     <Button
    //                       className=""
    //                       // color="red"
    //                       type="default"
    //                       icon={<DeleteOutlined />}
    //                       style={{ backgroundColor: "red", color: "white", width: "max-content", padding: "0px 5px" }}
    //                       onClick={(e) => removeAttachment(data)}
    //                     >
    //                       {/* Remove */}
    //                     </Button>
    //                   </Tooltip>
    //                 </div>
    //     );
    //   }
    // },
]
  return (
    <div style={{width:'100%',padding:'2em'}}> 
       {/* <Timeline items={items}/> */}
       <CustomeTableComponent
                enableInlineAdd={false}
                Headers={DependanciesHeaders}
                firstHeaderLabel=""
                data={data}
        ></CustomeTableComponent>
    </div>
  )
}
